module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/163-papua-new-guinea-7c3515c5a775b8f76f4f4153da96560c.svg";